import {withKnownRoute} from '../../lib/routes';
import {RulesPage} from './rules-page';

export default withKnownRoute(RulesPage);
